export const accessTokenKey = 'accessToken';

export const userData = 'userData';

export const gprSettings = 'gprSettings';
